<template lang="pug">
  div(':class'="{'has-error': isWordOver}")
    textarea.form-control(:name="name", v-model="text", rows="5", :maxlength="maxlength", @input="$emit('input', $event.target.value)", :placeholder="placeholder" data-testid="text-counter")
    p.help-block.text-right {{textlength}} / {{maxlength}}
</template>

<script>
export default {
  name: 'TextCounter',
  props: {
    name: {type: String, required: true},
    value: {type: String, required: false, default: ''},
    maxlength: {type: Number, required: true},
    placeholder: {type: String, required: false, default: ''}
  },
  data: function () {
    return {
      text: ''
    }
  },
  computed: {
    textlength: function () {
      return this.value.length
    },
    isWordOver: function () {
      return this.textlength > this.maxlength
    }
  },
  watch: {
    value: function (newValue, oldValue) {
      this.initData()
    }
  },
  created: function () {
    this.initData()
  },
  methods: {
    initData: function () {
      this.text = this.value
    }
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/molecules/TextCounter.vue